module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('scroller', {
    ref: "scroller"
  }, [_c('header', {
    staticClass: "header",
    class: {
      height: _vm.isWechat
    }
  }, [_c('div', {
    staticClass: "topbar"
  }, [_c('router-link', {
    staticClass: "btn-setting iconfont",
    class: {
      iconTop: _vm.isWechat
    },
    attrs: {
      "to": "/user/settings"
    }
  }), _vm._v(" "), (_vm.visible) ? _c('h1', {
    staticClass: "topbar-title"
  }, [_vm._v("我的")]) : _vm._e()], 1)]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderList.length !== 0),
      expression: "orderList.length !== 0"
    }],
    staticClass: "section-title"
  }, [_c('h4', {
    staticClass: "caption"
  }, [_vm._v("我的业务单")])]), _vm._v(" "), _c('div', {
    staticClass: "content-padded"
  }, [_c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderList.length !== 0),
      expression: "orderList.length !== 0"
    }],
    staticClass: "card-group"
  }, _vm._l((_vm.orderList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "card-item",
      on: {
        "click": function($event) {
          _vm.onItemClick(index)
        }
      }
    }, [_c('span', {
      staticClass: "status"
    }, [_vm._v(_vm._s(item.statusName))]), _vm._v(" "), _c('h4', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.productName))]), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_c('span', [_vm._v(_vm._s(item.no))])]), _vm._v(" "), _c('p', {
      staticClass: "date"
    }, [_vm._v("签约日期：" + _vm._s(item.signDate))])])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderList.length === 0 && !_vm.loading),
      expression: "orderList.length === 0 && !loading"
    }],
    staticClass: "no-order"
  }, [_c('div', {
    staticClass: "msg"
  }, [_vm._v("\n        暂无借款订单\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "btn"
  }, [_c('router-link', {
    attrs: {
      "to": "/borrow"
    }
  }, [_vm._v("立即申请借款")])], 1)])]), _vm._v(" "), _c('spinner', {
    attrs: {
      "show": _vm.loading
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6761a3d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/user.vue
// module id = 361
// module chunks = 1